import { Link } from "gatsby";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";
import styles from "./footer.module.less";
import { GatsbyImage } from "gatsby-plugin-image";

const Footer = ({ siteConfig }: { siteConfig: Queries.SiteConfigurationFragment }) => {
  const logo = siteConfig?.footerLogo;
  const footerLinks = siteConfig.footerLinks;
  const additionalFooterLinks = siteConfig.additionalFooterLinks;
  const phoneNumber = siteConfig.footerPhoneNumber;
  const address = siteConfig.footerAddress;
  const addressLink = siteConfig.footerAddressLink?.slug;
  const email = siteConfig.footerEmail;
  const socialMediaTitle = siteConfig.footerSocialMediaTitle;
  const socialMediaLinks = siteConfig.footerSocialMediaLinks;
  const parksAndResortsLink = siteConfig.footerParksAndResortsLink;
  const parksLinks = siteConfig.footerParksLinks;

  const hasImageFileUrl = (image: any) => {
    if (image && image.file) {
      return image.file.url ? true : false;
    }
    return false;
  };

  return (
    <div className={[styles.footer].join(" ")}>
      <div className={[styles.footerUpperWrapper, "block block--max-width-narrow"].join(" ")}>
        {logo?.gatsbyImageData && (
          <div className={styles.logoWrapper}>
            <GatsbyImage image={logo.gatsbyImageData} alt="Gröna Lund" />
          </div>
        )}
        {footerLinks instanceof Array && footerLinks.length && (
          <ul className={styles.list}>
            {footerLinks.map((link) => (
              <li key={link?.id} className={styles.listItem}>
                <Link className={["p_small", styles.footerLink].join(" ")} to={link?.slug || ""}>
                  {link?.title}
                </Link>
              </li>
            ))}
          </ul>
        )}
        <div className={styles.divider}></div>
        {additionalFooterLinks instanceof Array && additionalFooterLinks.length && (
          <ul className={styles.list}>
            {additionalFooterLinks.map((link) => (
              <li key={link?.id} className={styles.listItem}>
                <Link className={["p_small", styles.additionalLinks].join(" ")} to={link?.slug || ""}>
                  {link?.title}
                </Link>
              </li>
            ))}
          </ul>
        )}
        <ul className={[styles.list, styles.contactList].join(" ")}>
          {phoneNumber && (
            <li className={["p_tiny", styles.listItem, styles.contactListItem].join(" ")}>
              <span className={["icon-phone-android", styles.contactIcon].join(" ")}></span>
              <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </li>
          )}
          {address && (
            <li className={["p_tiny", styles.listItem, styles.contactListItem].join(" ")}>
              <span className={["icon-location", styles.contactIcon].join(" ")}></span>
              <LinkWrapper url={addressLink}>
                <span>{address}</span>
              </LinkWrapper>
            </li>
          )}
          {email && (
            <li className={["p_tiny", styles.listItem, styles.contactListItem].join(" ")}>
              <span className={["icon-send", styles.contactIcon].join(" ")}></span>
              <a href={`mailto:${email}`}>{email}</a>
            </li>
          )}
        </ul>
        <div className={styles.socialMediaWrapper}>
          <span className={["p_tiny", styles.socialMediaTitle].join(" ")}>{socialMediaTitle}</span>
          {socialMediaLinks instanceof Array && socialMediaLinks.length && (
            <ul className={[styles.list].join(" ")}>
              {socialMediaLinks.map((link) => (
                <li key={link?.id} className={[styles.listItem_flowing].join(" ")}>
                  <a
                    aria-label={link?.title || "Social Media Link"}
                    rel="noopener noreferrer"
                    target="_blank"
                    className={styles.socialMediaListLink}
                    href={link?.externalUrl || ""}
                  >
                    <span className={link?.linkIcon || ""}></span>
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className={styles.parksWrapper}>
        <div className="block--max-width-narrow">
          {parksAndResortsLink && (
            <a
              rel="noopener noreferrer"
              className={styles.parksLogo}
              target="_blank"
              href={parksAndResortsLink.externalUrl ?? ""}
            >
              {hasImageFileUrl(parksAndResortsLink.image) && (
                <img
                  loading="lazy"
                  src={parksAndResortsLink.image?.file?.url ?? ""}
                  className={styles.parksLogo}
                  alt={parksAndResortsLink.title ? parksAndResortsLink.title : ""}
                />
              )}
            </a>
          )}
          {parksLinks instanceof Array && parksLinks.length && (
            <ul className={[styles.list_centered].join(" ")}>
              {parksLinks.map((link) => (
                <li key={link?.id} className={[styles.listItem_flowing].join(" ")}>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={link?.externalUrl ?? ""}
                    className={styles.parksListLink}
                  >
                    {hasImageFileUrl(link?.image) && (
                      <img loading="lazy" src={link?.image?.file?.url || ""} alt={link?.title ? link?.title : ""} />
                    )}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
